import React from 'react';
import PropTypes from 'prop-types';

import { ANNUAL_POWER_STEPS, DEFAULT_STEPS } from './constants';
import styles from './registrationStepIndicator.scss';

const RegistrationStepIndicator = ({
    showAnnualPowerStep,
    isUpgradeStep,
    isCheckoutStep,
    hideSteps,
    hideTitle,
    titleText,
    onBack,
    backTitle,
    backTestId,
    onClose,
    closeTestId,
    closeIconTestId,
    'data-testid': dataTestId,
}) => {
    const steps = showAnnualPowerStep ? ANNUAL_POWER_STEPS : DEFAULT_STEPS;
    const showTitle = isUpgradeStep && !hideTitle;

    const currentStep = (() => {
        if (isUpgradeStep) {
            return steps[0].number;
        }
        if (isCheckoutStep) {
            return steps[steps.length - 1].number;
        }
        return showAnnualPowerStep ? steps[1].number : steps[0].number;
    })();

    const backButton = onBack && (
        <div
            className={styles.headerBack}
            onClick={onBack}
            title={backTitle}
            data-testid={backTestId || (dataTestId && `${dataTestId}.back-btn`)}
        >
            <i className="utr utr-prev" />
        </div>
    );

    const closeButton = onClose && (
        <div
            className={styles.headerClose}
            onClick={onClose}
            data-testid={closeTestId || (dataTestId && `${dataTestId}.close-btn`)}
        >
            <img className="close-icon" src="/img/icons/sidebar-close-icon.svg" alt="" data-testid={closeIconTestId || (dataTestId && `${dataTestId}.close-icon`)} />
        </div>
    );

    // The controls keep their header row even where the title is suppressed — once the
    // upgrade completes the player is an annual Power member and the title goes, and
    // letting the row go with it moved the back and close into the panel's top corners
    // partway through the flow.
    const showHeaderRow = showTitle || Boolean(backButton) || Boolean(closeButton);

    return (
        <div className={`${styles.registrationStepIndicator} ${hideSteps ? styles.titleOnly : ''}`} data-test="registration-step-indicator">
            {showHeaderRow && (
                <div
                    className={`${styles.header} ${showTitle ? '' : styles.headerControlsOnly}`}
                    data-testid={dataTestId && `${dataTestId}.header`}
                >
                    {backButton}
                    {showTitle && (
                        <div className={styles.title} data-test="step-indicator-title" data-testid={dataTestId && `${dataTestId}.title`}>{titleText}</div>
                    )}
                    {closeButton}
                </div>
            )}
            {!hideSteps && (
                <div className={styles.steps}>
                    {steps.map((step) => {
                        const isActive = step.number === currentStep;
                        return (
                            <div
                                key={step.number}
                                className={`${styles.step} ${isActive ? styles.active : ''}`}
                                data-test={`step-${step.number}`}
                                data-active={isActive}
                            >
                                <div className={styles.circle}>{step.number}</div>
                                <span className={styles.label}>{step.label}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

RegistrationStepIndicator.propTypes = {
    showAnnualPowerStep: PropTypes.bool,
    isUpgradeStep: PropTypes.bool,
    isCheckoutStep: PropTypes.bool,
    hideSteps: PropTypes.bool,
    hideTitle: PropTypes.bool,
    titleText: PropTypes.string,
    onBack: PropTypes.func,
    backTitle: PropTypes.string,
    backTestId: PropTypes.string,
    onClose: PropTypes.func,
    closeTestId: PropTypes.string,
    closeIconTestId: PropTypes.string,
    'data-testid': PropTypes.string,
};

RegistrationStepIndicator.defaultProps = {
    showAnnualPowerStep: false,
    isUpgradeStep: false,
    isCheckoutStep: false,
    hideSteps: false,
    hideTitle: false,
    titleText: 'This event requires an annual Power membership',
    onBack: null,
    backTitle: null,
    backTestId: null,
    onClose: null,
    closeTestId: null,
    closeIconTestId: null,
    'data-testid': null,
};

export default RegistrationStepIndicator;
